import { createApp } from 'vue'
import { createRouter, createWebHashHistory } from 'vue-router';
import Inquiry from '../component/view/Inquiry.vue';
import {sendViewEvent} from "../util/Ga4EventUtil";

/**
 * pictlink-webへの移行に伴いお問い合わせページへリダイレクトする
 * ルール:
 *   1. /sp → /web に変換
 *   2. # を除去しパスに変換（クエリパラメータ・インページアンカーは保持）
 *   3. input/以降のパスはそのまま保持
 *
 * 例:
 *   /sp/common/inquiry#/input/puriget → /web/common/inquiry/input/puriget
 *   /sp/common/inquiry#/ → /web/common/inquiry
 *   /sp/common/inquiry_puri#/input/puriget → /web/common/inquiry_puri/input/puriget
 */
export const buildRedirectUrl = (hashPath) => {
    // /sp/common/inquiry or /sp/common/inquiry_puri → /web/common/inquiry or /web/common/inquiry_puri
    const basePath = location.pathname.replace('/sp/', '/web/');
    // hashPathが '/' のみの場合はベースパスのみ
    const subPath = hashPath === '/' ? '' : hashPath;
    return basePath + subPath + location.search;
}

export const redirectWithPath = (to) => {
    // アプリのWebViewが開く最初の画面が旧URLの場合、履歴を残すと戻るボタンで
    // 旧URL→再リダイレクトを繰り返しアプリに戻れなくなるためlocation.replaceを使う
    window.location.replace(buildRedirectUrl(to.fullPath));
    return false;
}

/**
 * ピクトリンクフォトお問い合わせページへのリダイレクトURLを生成する
 * ルール:
 *   1. /pictlinkPhotos プレフィックスを除去して /web/common/inquiry_pictlink_photos に変換する
 *   2. /input/pictlinkPhotos は /web/common/inquiry_pictlink_photos/input に変換する
 *
 * 例:
 *   /sp/common/inquiry#/pictlinkPhotos/input → /web/common/inquiry_pictlink_photos/input
 *   /sp/common/inquiry#/pictlinkPhotos/input/login_pictlink_photos → /web/common/inquiry_pictlink_photos/input/login_pictlink_photos
 *   /sp/common/inquiry#/input/pictlinkPhotos → /web/common/inquiry_pictlink_photos/input
 */
export const buildPictlinkPhotosRedirectUrl = (hashPath) => {
    const subPath = hashPath
        .replace(/^\/pictlinkPhotos/, '')
        .replace(/^\/input\/pictlinkPhotos$/, '/input');
    return '/web/common/inquiry_pictlink_photos' + subPath + location.search;
}

export const redirectToPictlinkPhotos = (to) => {
    // redirectWithPathと同じ理由で履歴を残さないlocation.replaceを使う
    window.location.replace(buildPictlinkPhotosRedirectUrl(to.fullPath));
    return false;
}

// Vue Router 4ではcomponentもredirectもないルートはマッチング対象外となるため、
// beforeEnterのみのルートにもダミーコンポーネントを設定する
const RedirectComponent = { template: '' };

export const routes = [
    {
        path: '/',
        name: 'root',
        component: RedirectComponent,
        beforeEnter: redirectWithPath,
    },
    {
        path: '/input',
        component: RedirectComponent,
        beforeEnter: redirectWithPath,
    },
    {
        path: '/input/pictlinkPhotos',
        component: RedirectComponent,
        beforeEnter: redirectToPictlinkPhotos,
    },
    {
        path: '/input/:category(puriget|login|withdrawal|jhs_premium|seishun_sponsor|other)',
        component: RedirectComponent,
        beforeEnter: redirectWithPath,
    },
    {
        path: '/pictlinkPhotos/input',
        component: RedirectComponent,
        beforeEnter: redirectToPictlinkPhotos,
    },
    {
        path: '/pictlinkPhotos/input/:category(login_pictlink_photos|backup_pictlink_photos|save_pictlink_photos|status_pictlink_photos|other_pictlink_photos)',
        component: RedirectComponent,
        beforeEnter: redirectToPictlinkPhotos,
    },
    {
        path: '/:pathMatch(.*)*',
        redirect: { name: 'root' }
    }
];

const router = createRouter({
    history: createWebHashHistory(),
    routes,
    scrollBehavior() {
        return { top: 0 }
    },
});

router.afterEach((to) => {
    sendViewEvent(to.path)
})

const vue = createApp(Inquiry)
    .use(router)
    .mount('#inquiry');

export default vue
